import { configureStore, Middleware } from '@reduxjs/toolkit';
import authReducer, { setToken } from '../features/auth/authSlice';
import { apiSlice } from '../api/apiSlice';

// The authenticated identity can change without a page reload -- login,
// logout, or switching which club membership is active (ClubSwitcher).
// Endpoints that don't take the user/club id as an argument (e.g.
// getMyClubs) have a single shared cache entry, so without this they'd keep
// serving whatever was cached for the previous identity until some
// unrelated mutation happened to invalidate them.
const resetApiCacheOnAuthChange: Middleware = (storeApi) => (next) => (action) => {
    const result = next(action);
    if (setToken.match(action)) {
        storeApi.dispatch(apiSlice.util.resetApiState());
    }
    return result;
};

export const store = configureStore({
    reducer: {
        auth: authReducer,
        [apiSlice.reducerPath]: apiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(apiSlice.middleware, resetApiCacheOnAuthChange),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
